import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms-video",
  "use": "icon-sms-video-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-sms-video\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m0-965.485714a453.485714 453.485714 0 1 0 453.485714 453.485714A453.485714 453.485714 0 0 0 512 58.514286z\" fill=\"#ffffff\" p-id=\"2898\" /><path d=\"M424.228571 737.28a73.142857 73.142857 0 0 1-36.571428-9.947429 72.118857 72.118857 0 0 1-36.571429-63.341714V360.009143a73.142857 73.142857 0 0 1 109.714286-63.341714l263.314286 151.990857a73.142857 73.142857 0 0 1 0 126.683428l-263.314286 151.990857a73.142857 73.142857 0 0 1-36.571429 9.947429z m0-392.045714a14.628571 14.628571 0 0 0-7.314285 2.048 14.628571 14.628571 0 0 0-7.314286 12.726857v303.981714a14.628571 14.628571 0 0 0 7.314286 12.726857 14.628571 14.628571 0 0 0 14.628571 0l263.314286-151.990857a14.628571 14.628571 0 0 0 0-25.453714l-263.314286-151.990857a14.628571 14.628571 0 0 0-7.314286-2.048z\" fill=\"#ffffff\" p-id=\"2899\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-video.svg
// module id = 2I1J
// module chunks = 29